module.exports = __webpack_public_path__ + "static/media/guide.58699455.png";